import React from 'react';
import { Bot } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

export default function TypingIndicator({ typingUsers }) {
    const { theme } = useTheme();

    if (!typingUsers || typingUsers.length === 0) return null;

    const botTyping = typingUsers.find(u => u._isBot || u.is_bot);
    const humanTyping = typingUsers.filter(u => !u._isBot && !u.is_bot);

    return (
        <div className="px-4 py-1 space-y-1">
            {/* Bot thinking indicator — persistent and distinct */}
            {botTyping && (
                <div className={`flex items-center gap-2 text-xs font-rasa ${
                    theme === 'dark' ? 'text-purple-400' : 'text-purple-600'
                }`}>
                    <Bot size={14} className="flex-shrink-0" />
                    <span className="font-semibold">JPRO</span>
                    <span>is thinking</span>
                    <div className="flex gap-0.5">
                        <span className="w-1 h-1 rounded-full bg-purple-500 animate-bounce" style={{ animationDelay: '0ms' }} />
                        <span className="w-1 h-1 rounded-full bg-purple-500 animate-bounce" style={{ animationDelay: '200ms' }} />
                        <span className="w-1 h-1 rounded-full bg-purple-500 animate-bounce" style={{ animationDelay: '400ms' }} />
                    </div>
                </div>
            )}

            {/* Human typing indicator */}
            {humanTyping.length > 0 && (
                <div className={`flex items-center gap-2 text-xs font-rasa ${
                    theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
                }`}>
                    <div className="flex gap-0.5">
                        <span className="w-1.5 h-1.5 rounded-full bg-current animate-bounce" style={{ animationDelay: '0ms' }} />
                        <span className="w-1.5 h-1.5 rounded-full bg-current animate-bounce" style={{ animationDelay: '150ms' }} />
                        <span className="w-1.5 h-1.5 rounded-full bg-current animate-bounce" style={{ animationDelay: '300ms' }} />
                    </div>
                    <span>
                        {humanTyping.length === 1
                            ? `${humanTyping[0].username} is typing`
                            : humanTyping.length === 2
                                ? `${humanTyping[0].username} and ${humanTyping[1].username} are typing`
                                : `${humanTyping[0].username} and ${humanTyping.length - 1} others are typing`
                        }
                    </span>
                </div>
            )}
        </div>
    );
}
